import _ from "lodash";

const ABC_CODE = {
   A: { value: 2, label: "A" },
   B: { value: 3, label: "B" },
   C: { value: 4, label: "C" },
};

const ABC_CODE_LIST = [
   { value: 0, label: "---All---" },
   { value: 2, label: "A" },
   { value: 3, label: "B" },
   { value: 4, label: "C" },
   { value: 1, label: "Not Assigned" },
];

const ATTACHMENT_TYPES = {
   MachineSetup: 1,
   Employee: 2,
   Customer: 3,
   Vendor: 4,
   Item: 5,
   ProcessChangeRequest: 6,
   NewItemRequest: 7,
   PurchaseOrder: 8,
   SalesOrderInvoice: 9,
   CorrectiveAction: 10,
   SupplierCorrectiveAction: 11,
   InternalCorrectiveAction: 12,
   PreventativeAction: 13,
   SampleItemRequest: 14,
};

const AUTO_NUMS_TYPE = {
   FinishedGoodSpecification: 0,
   Order: 1,
   ChemicalTreatment: 2,
   ChemicalSpecification: 3,
   PurchasedMaterial: 4,
   TestNumber: 5,
   InProcessBulk: 6,
   JorunalId: 7,
   SampleSpecification: 8,
   SampleItemNumber: 9,
   DropShip: 10,
};

const BARCODE_TYPE = {
   Unknown: 0,
   Inventory: 1,
   MachinePart: 2,
   InventoryTransfer: 3,
   ConsignedInventory: 4,
   SalesOrder: 5,
};

const BOM_GROUP = {
   Undefined: 0,
   Chemical: 1,
   Packaging: 2,
   Yarn: 3,
};

const BREAKPOINTS = {
   mobile: 320,
   mobileLandscape: 480,
   smallDesktop: 768,
   tablet: 856,
   tabletLandscape: 992,
   desktop: 1080,
   desktopLarge: 1500,
   desktopWide: 1920,
};

const CALCULATION_TYPES = {
   // Machine Setup Calculation Types
   UNKNOWN: { value: "X", label: "--- Select ---" }, // this shouldn't be in the drop down fyi
   SOLE_SETUP: { value: "S", label: "Sole Setup", seq: 1 },
   ALTERNATE: { value: "A", label: "Alternate", seq: 2 },
   CUMULATIVE: { value: "C", label: "Cumulative", seq: 3 },
};

const COLOR_OPTIONS = [
   { value: 0, label: "Gray", hexCode: "#A7B0B7" },
   { value: 1, label: "Purple", hexCode: "#303082" },
   { value: 2, label: "Orange", hexCode: "#DF7953" },
   { value: 3, label: "Light Purple", hexCode: "#6E6EA8" },
   { value: 4, label: "Green", hexCode: "#799E51" },
   { value: 5, label: "Blue", hexCode: "#023f72" },
   { value: 6, label: "Light Blue", hexCode: "#7C9EB2" },
];

const CONSIGN_BARCODE_LEN = {
   PickTicket: 6,
   SalesOrder: 9,
   Inventory: 11,
   Shipment: 12,
};

const CORRECTIVE_ACTION_STATUSES = {
   All: 0,
   Open: 1,
   Closed: 2,
   //AwaitingFollowup: 3,   2022-10-28  No longer in use
   //Pending: 4,            2022-10-28  No longer in use
   Canceled: 5,
};

const CORRECTIVE_ACTION_STATUSES_SELECT = [
   { label: "--- All ---", value: CORRECTIVE_ACTION_STATUSES.All },
   { label: "Open", value: CORRECTIVE_ACTION_STATUSES.Open },
   { label: "Closed", value: CORRECTIVE_ACTION_STATUSES.Closed },
   { label: "Canceled", value: CORRECTIVE_ACTION_STATUSES.Canceled },
];

const CORRECTIVE_ACTION_TYPES = {
   Select: -1,
   All: 0,
   CorrectiveAction: 1,
   PreventativeAction: 2,
   SupplierAction: 3,
   InternalAction: 4,
};

const CORRECTIVE_ACTION_TYPES_NEW = [
   { label: "--- Select ---", value: CORRECTIVE_ACTION_TYPES.Select },
   {
      label: "Corrective Action",
      value: CORRECTIVE_ACTION_TYPES.CorrectiveAction,
   },
   {
      label: "Preventative Action",
      value: CORRECTIVE_ACTION_TYPES.PreventativeAction,
   },
   {
      label: "Supplier Corrective Action",
      value: CORRECTIVE_ACTION_TYPES.SupplierAction,
   },
   {
      label: "Internal Corrective Action",
      value: CORRECTIVE_ACTION_TYPES.InternalAction,
   },
];

const CORRECTIVE_ACTION_TYPES_SEARCH = [
   { label: "--- All ---", value: CORRECTIVE_ACTION_TYPES.All },
   {
      label: "Corrective Action",
      value: CORRECTIVE_ACTION_TYPES.CorrectiveAction,
   },
   {
      label: "Preventative Action",
      value: CORRECTIVE_ACTION_TYPES.PreventativeAction,
   },
   {
      label: "Supplier Corrective Action",
      value: CORRECTIVE_ACTION_TYPES.SupplierAction,
   },
   {
      label: "Internal Corrective Action",
      value: CORRECTIVE_ACTION_TYPES.InternalAction,
   },
];

const COUNTRY_LIST = [
   // <option value="-1">--- Select Country ---</option>
   "Afghanistan",
   "Albania",
   "Algeria",
   "American Samoa",
   "Andorra",
   "Angola",
   "Anguilla",
   "Antarctica",
   "Antigua and Barbuda",
   "Argentina",
   "Armenia",
   "Aruba",
   "Australia",
   "Austria",
   "Azerbaijan",
   "Bahamas",
   "Bahrain",
   "Bangladesh",
   "Barbados",
   "Belarus",
   "Belgium",
   "Belize",
   "Benin",
   "Bermuda",
   "Bhutan",
   "Bolivia",
   "Bosnia and Herzegovina",
   "Botswana",
   "Bouvet Island",
   "Brazil",
   "British Indian Ocean Territory",
   "British Virgin Islands",
   "Brunei Darussalam",
   "Bulgaria",
   "Burkina Faso",
   "Burundi",
   "Cambodia",
   "Cameroon",
   "Canada",
   "Cape Verde",
   "Cayman Islands",
   "Central African Republic",
   "Chad",
   "Chile",
   "China",
   "Christmas Island",
   "Cocos",
   "Colombia",
   "Comoros",
   "Congo",
   "Cook Islands",
   "Costa Rica",
   "Croatia",
   "Cuba",
   "Cyprus",
   "Czech Republic",
   "Denmark",
   "Djibouti",
   "Dominica",
   "Dominican Republic",
   "East Timor",
   "Ecuador",
   "Egypt",
   "El Salvador",
   "Equatorial Guinea",
   "Eritrea",
   "Estonia",
   "Ethiopia",
   "Falkland Islands",
   "Faroe Islands",
   "Fiji",
   "Finland",
   "France",
   "French Guiana",
   "French Polynesia",
   "French Southern Territories",
   "Gabon",
   "Gambia",
   "Georgia",
   "Germany",
   "Ghana",
   "Gibraltar",
   "Greece",
   "Greenland",
   "Grenada",
   "Guadeloupe",
   "Guam",
   "Guatemala",
   "Guinea",
   "Guinea-Bissau",
   "Guyana",
   "Haiti",
   "Heard and McDonald Islands",
   "Honduras",
   "Hong Kong",
   "Hungary",
   "Iceland",
   "India",
   "Indonesia",
   "Iran",
   "Iraq",
   "Ireland",
   "Israel",
   "Italy",
   "Ivory Coast",
   "Jamaica",
   "Japan",
   "Jordan",
   "Kazakhstan",
   "Kenya",
   "Kiribati",
   "Kuwait",
   "Kyrgyzstan",
   "Laos",
   "Latvia",
   "Lebanon",
   "Lesotho",
   "Liberia",
   "Libya",
   "Liechtenstein",
   "Lithuania",
   "Luxembourg",
   "Macau",
   "Macedonia",
   "Madagascar",
   "Malawi",
   "Malaysia",
   "Maldives",
   "Mali",
   "Malta",
   "Marshall Islands",
   "Martinique",
   "Mauritania",
   "Mauritius",
   "Mayotte",
   "Mexico",
   "Micronesia",
   "Moldova",
   "Monaco",
   "Mongolia",
   "Montserrat",
   "Morocco",
   "Mozambique",
   "Myanmar",
   "Namibia",
   "Nauru",
   "Nepal",
   "Netherlands",
   "Netherlands Antilles",
   "New Caledonia",
   "New Zealand",
   "Nicaragua",
   "Niger",
   "Nigeria",
   "Niue",
   "Norfolk Island",
   "North Korea",
   "Northern Mariana Islands",
   "Norway",
   "Oman",
   "Pakistan",
   "Palau",
   "Panama",
   "Papua New Guinea",
   "Paraguay",
   "Peru",
   "Philippines",
   "Pitcairn",
   "Poland",
   "Portugal",
   "Puerto Rico",
   "Qatar",
   "Reunion",
   "Romania",
   "Russian Federation",
   "Rwanda",
   "S. Georgia and S. Sandwich Islands",
   "Saint Kitts and Nevis",
   "Saint Lucia",
   "Saint Vincent and The Grenadines",
   "Samoa",
   "San Marino",
   "Sao Tome and Principe",
   "Saudi Arabia",
   "Senegal",
   "Seychelles",
   "Sierra Leone",
   "Singapore",
   "Slovakia",
   "Slovenia",
   "Solomon Islands",
   "Somalia",
   "South Africa",
   "South Korea",
   "Soviet Union",
   "Spain",
   "Sri Lanka",
   "St. Helena",
   "St. Pierre and Miquelon",
   "Sudan",
   "Suriname",
   "Svalbard and Jan Mayen Islands",
   "Swaziland",
   "Sweden",
   "Switzerland",
   "Syria",
   "Taiwan",
   "Tajikistan",
   "Tanzania",
   "Thailand",
   "Togo",
   "Tokelau",
   "Tonga",
   "Trinidad and Tobago",
   "Tunisia",
   "Turkey",
   "Turkmenistan",
   "Turks and Caicos Islands",
   "Tuvalu",
   "Uganda",
   "Ukraine",
   "United Arab Emirates",
   "United Kingdom",
   "United States",
   "Uruguay",
   "US Minor Outlying Islands",
   "US Virgin Islands",
   "Uzbekistan",
   "Vanuatu",
   "Venezuela",
   "Viet Nam",
   "Wallis and Futuna Islands",
   "Western Sahara",
   "Yemen",
   "Yugoslavia",
   "Zaire",
   "Zambia",
   "Zimbabwe",
];

const DATA_TYPES = {
   INT: "integer",
   FLOAT: "float",
   TEXT: "text",
   BOOL: "boolean",
   SMALLINT: "smallint",
   DECIMAL: "decimal",
   DOUBLE: "double",
};

const DATE_RANGE_TYPE = {
   ShipDateRange: 0,
   EndShipDateOnly: 1,
   OrderDateRange: 2,
};

const DEVICE_TYPES = [
   { label: "Desktop or Laptop", value: 0, isMobile: false, hasScanner: false },
   { label: "Handheld Scanner", value: 1, isMobile: true, hasScanner: true },
   {
      label: "Mobile (Phone/Tablet/etc)",
      value: 2,
      isMobile: true,
      hasScanner: false,
   },
];

const DOCUMENT_TYPES = {
   Other: 0,
   BillOfLading: 10,
   CreditApplication: 20,
   Image: 30,
   Invoice: 40,
   NCSalesTaxExemptionForm: 45,
   PackingList: 50,
   PurchaseOrder: 60,
   ProductSpecification: 70,
   ProposalOrQuote: 80,
   ReceivingPMCheck: 82,
   SupplierSpecification: 85,
};

const ENDPOINTS = {
   addInventory: "/add-inventory", // Mobile menu item
   addressEditor: "/ea",
   adminDefaults: "/admin/defaults",
   adminMaint: "/admin/maint",
   billOfLading: "/bill-of-lading",
   bomComponents: "/bom-components",
   bomComponentsParam: "/bom-components/search",
   bomComponentsUseParams: "/bom-components/:bomComponent",
   coneLookup: "/cone-lookup",
   coneLookupMobile: "/cone-lookup-scan",  // Mobile menu item
   coneRecordSearch: "/cone-record-search",
   consignedInventory: "/consigned-inventory",
   consignedInventoryUsage: "/consigned-inventory-usage",
   consignedTransfer: "/consigned-transfer", // Mobile menu item
   copySpec: "/copy-specification",
   correctiveActionEdit: "/corrective-action-edit",
   correctiveActionSearch: "/corrective-active-search",
   correctiveActionPreventativeEdit: "/preventative-action-edit",
   correctiveActionSupplierEdit: "/supplier-action-edit",
   correctiveInternalActionEdit: "/internal-corrective-action",
   costQuote: "/cost-quote",
   costQuoteEdit: "/cost-quote/:id",
   costQuoteLookup: "/quote-lookup",
   countScan: "/count-scan", // Mobile
   countSearch: "/count-search", // Mobile menu item
   createCoA: "/create-coa",
   createCoAParams: "/create-coa/:order/:item/:cust/:isConsigned",
   createCount: "/create-count", // Mobile
   createItemCode: "/create-item-code",
   createMachinePartCode: "/create-machine-part-code",
   createProductionItem: "/create-production-item",
   createSampleItem: "/create-sample-item",
   customerDashboard: "/customer-dashboard",
   customerDashboardParam: "/customer-dashboard/:customerId",
   customerCard: "/customer-card",
   customerMachinePartsPricing: "/customer-machine-parts-pricing",
   customerMachinePartsPricingParam: "/customer-machine-parts-pricing/:customerObject",
   devTest: "/dev-test",
   editTestItem: "/edit-test-results",
   employeeAttendanceReport: "/employee-attendance-report",
   // employeeTransactionEntry: "/employee-transaction-entry",
   engTools: "/eng-tools",
   enterQualityTestData: "/enter-quality-test-data",
   eventViewer: "/admin/events",
   explodeCase: "/explode-case",
   globalBOMUpdate: "/global-bom-update",
   home: "/",
   inventoryCountPosting: "/inventory-count-posting",
   inventoryDashboard: "/inventoryDashboard",
   inventoryDashboardParam: "/inventoryDashboard/:itemNumber",
   inventoryLabels: "/inventory-labels",
   inventoryStockStatus: "/inventory-stock-status",
   inventoryTrackingTools: "/inventory-tracking-tools",
   invoices: "/invoices",
   invoiceSettings: "/invoice-settings",
   itemClassMaintenance: "/item-class-maintenance",
   itemLookup: "/item-lookup", // Mobile menu item (potentially useful to non-mobile)
   itemPriceReport: "/item-price-report",
   itemSiteOrders: "/item-site-orders",
   labelWeight: "/label-weight", // Mobile side (called from add inventory)
   landedSearch: "/landed-search",
   lateShipment: "/late-shipment",
   machineLabels: "/machine-labels",
   machineManagement: "/machine-management",
   machinePartPricingMaintenance: "/machine-part-pricing-maintenance",
   machineSetups: "/machine-setups",
   machineSetupsParam: "/machine-setups/:machineSetupSelect",
   machineWorkorderProcessing: "/machine-workorder-processing",
   massUpdateBOMLineItem: "/mass-update-bom-line-item",
   mobileBomLookup: "/item-bom-lookup",
   mobileHome: "/mobile",
   mobileRwoCreate: "/mobile-rwo-create", // Mobile QR Scanned
   mobileRwoEdit: "/mobile-rwo", // Mobile
   mobileRwoNew: "/mobile-rwo-new", // Mobile manual entry
   mobileRwoScan: "/mobile-rwo-scan", // Mobile
   mobileRwoSearch: "/mobile-rwo-search", // Mobile menu item (more limited than the desktop side)
   mostSold: "/most-sold",
   moveIVLabelToNewSite: "/move-iv-label-to-new-site",
   moveOrder: "/move-order", // Mobile
   moveOrders: "/move-orders", // Mobile menu item
   negativeInventory: "/negative-inventory",
   newMobileHome: "/m/", // New mobile SPA (/m/* rebuild) — full-page nav target, separate SPA
   newProdRecord: "/new-production-record",
   onTimeDeliveryReport: "/on-time-delivery-report",
   order: "/order",
   orderHold: "/order-hold",
   palletLabels: "/pallet-labels",
   noBomPlanning: "/no-bom-planning",
   partsManager: "/parts-manager",
   planningSchedule: "planning-schedule",
   poReport: "/po-report",
   pphCalculator: "/pph-calculator",
   pphCalculatorParam: "/pph-calculator/:itemNumber",
   printConeLabels: "/print-cone-labels",
   printerDefaults: "/default-printers", // Mobile menu, may be useful to non-mobile
   priorityItems: "/priority-items",
   processChanges: "/process-changes",
   processChangeEdit: "/process-change",
   processInvoices: "/process-invoices",
   productionPlanning: "/production-planning",
   productionPlanningForSpecifiedItem: "/production-planning-item",
   productionPmNeeds: "/production-pm-needs",
   productionReports: "/production-reports",
   productionWorkOrders: "/production-work-orders",
   purchaseMaterialCheck: "/pm-check", // Mobile menu
   purchaseOrderPlanning: "/pm-purchase-order-planning",
   purchasePriceHistory: "/pm-price-history",
   purchasePriceHistoryUseParams: "/pm-price-history/:itemNumber",
   qcHold: "qc-hold",
   qrCodeLookup: "/qr-code-lookup", // Mobile menu
   qualitySpecifications: "/quality-specifications",
   qualitySpecificationsParam: "/quality-specifications/:qualitySelect",
   quoteGenerator: "/quote-generator",
   rawMaterialUsage: "/raw-usage",
   //receiving: "/receiving", // Mobile menu
   receivingLabelManager: "/receiving-label-manager",
   repairWorkOrder: "/rwo",
   reportPreview: "/admin/report-preview",
   automationHealth: "/admin/automation-health",
   resetCase: "/admin/reset-case",
   roleManager: "/admin/roles",
   rwoSearch: "/rwo-search",
   salesCallTracking: "/sales-call-tracking",
   salesCallTrackingEdit: "/sales-call-tracking-edit",
   salesDashboard: "/sales-dashboard",
   salesFulfillment: "/sales-fulfillment", // Mobile menu
   salesReport: "/sales-report",
   scanProduction: "/scan-production", // Mobile menu
   shippingLookup: "/shipping-lookup",
   shippingSchedule: "/shipping-schedule",
   spliceReqs: "/splice-reqs",
   supplierPerformance: "/supplier-performance",
   tareChecks: "/tare-checks",
   threadFinder: "/thread-finder",
   topVendors: "/top-vendors",
   transfer: "/transfer", // Mobile
   transfers: "/transfers", // Mobile menu (list of open transfers)
   upsEditor: "/ups-accounts",
   userAdmin: "/admin/users",
   vendorDashboard: "/vendor-dashboard",
   vendorDashboardParam: "/vendor-dashboard/:vendorId",
   vendorInvoices: "/vendor-invoices",
   vendorItemRqst: "/vendor-item-rqst",
   vendorItemScan: "/vendor-item-scan", // Mobile menu item
   whereUsed: "/where-used",
   workOrderDetail: "/work-order-detail",
};

//IMPORTANT! If the FINISHED_GOOD_CLASS_CODES is changed please make the same changes to the FinishedGoodClassCodes list in appSettings.json
const FINISHED_GOOD_CLASS_CODES = [
   "ARAMIDEA",
   "ARAMIDLBS",
   "COMM-F",
   "COMM-FIL",
   "DSHIP",
   "FILA-EA",
   "FILA2",
   "FILAMENT",
   "SPUN",
   "SPUN-EA",
   "SPUN2",
   "TREAT- EA",
   "TREATED",
];

const flipCheckBox = (idx) => {
   let oppositeChckBoxIdx = _.findIndex(
      StockStatusFieldObjects,
      ["type", INPUT_TYPES.checkboxANDInput] && ["value", true]
   );
   StockStatusFieldObjects[oppositeChckBoxIdx].value = false;
   if (StockStatusFieldObjects[oppositeChckBoxIdx]?.typeAhead) {
      StockStatusFieldObjects[oppositeChckBoxIdx].textValue = {
         label: "--- All ---",
         value: "",
      };
   } else {
      StockStatusFieldObjects[oppositeChckBoxIdx].textValue = "";
   }
   StockStatusFieldObjects[idx].value = true;
};

const GenViewDataPayLoad = (state) => {
   const {
      itemNumberText,
      itemDescriptionPartialText,
      abcCodes,
      itemClasses,
      locations,
      showZeroQty,
      sortField,
      sortDirection,
      gridMode,
   } = state;

   let payload = {
      ItemNumber: itemNumberText?.value,
      ItemDescription: itemDescriptionPartialText,
      ABCCode: abcCodes?.value,
      ClassList: _.map(itemClasses, (x) => {
         return x?.value;
      }),
      SiteList: _.map(locations, (x) => {
         return x?.value;
      }),
      ShowZeroQty: showZeroQty,
      SortField: sortField,
      SortDirection: sortDirection,
      Mode: gridMode,
   };

   return payload;
};

const GetBarcodeType = (barcode) => {
   let size = barcode.length;
   let bc = barcode.toUpperCase();

   // ----------------------------------
   // Parse barcodes with strings first
   // ----------------------------------
   if (size > 20) {
      if (bc.substring(0, 8) === "TRANSFER") {
         // Inventory Transfer and Receiving QR Code Label
         return BARCODE_TYPE.InventoryTransfer;
      }
      if (bc.substring(0, 4) === "CASE" || bc.substring(0, 4) === "BULK") {
         // FG or IP work order case QR Code Labels
         return BARCODE_TYPE.Inventory;
      }
      if (bc.substring(0, 4) === "PART") {
         // MP inventory QR Code Label
         return BARCODE_TYPE.MachinePart;
      }
      if (bc.substring(0, 9) === "CONSIGNED") {
         // Consigned Shipping QR Code Label
         return BARCODE_TYPE.Inventory;
      }
   }

   if (size > 3 && (bc.substring(0, 3) === "SO-" || bc.substring(0, 3) === "SP-")) {
      // Sales or Sample order
      return BARCODE_TYPE.SalesOrder;
   }

   if (size > 2 && bc.substring(0, 2) === "IV") {
      // Inventory Transfer and Receiving
      return BARCODE_TYPE.InventoryTransfer;
   }

   // -----------------------------
   // Parse barcodes by length last
   // -----------------------------
   if (size === 8 || size === 11 || size === 12) {
      if (size > 10 && bc.substring(0, 1) === "9") {
         return BARCODE_TYPE.MachinePart;
      }
      // 8 or 11 digit FG or IP work order case
      // 12 digit consigned shipping label
      return BARCODE_TYPE.Inventory;
   }

   if (size === 10 || size === 17) {
      // Consigned Transfer Pick Ticket
      return BARCODE_TYPE.ConsignedInventory;
   }

   if (size === 9) {
      return BARCODE_TYPE.SalesOrder;
   }

   return BARCODE_TYPE.Unknown;
};

const GetProperCaseWord = (word) => {
   if (!word) return "";
   word = word.toLowerCase().trim();
   return word.charAt(0).toUpperCase() + word.slice(1);
}

const GetRealBarcode = (barcode) => {
   //--------------------------------------------------------------
   // Server side should use the AppHelpers static method with the
   // same name. Please keep them in sync with one another.
   //--------------------------------------------------------------
   // If a QR code was scanned then parse out just the barcode from the data
   let val = barcode?.length > 0 ? barcode.toUpperCase() : "";
   if (val.length > 20) {
      // BulkInventoryLabel, 01234567890, {... remaining QR Code contents}
      // CaseInventoryLabel, 01234567890, {... remaining QR Code contents}
      // PartInventoryLabel, 90001001234, {... remaining QR Code contents}
      val = (val.substring(0, 4) === "BULK"
         || val.substring(0, 4) === "CASE"
         || val.substring(0, 4) === "PART")
         ? val.substring(20, 31)  // 11 digits
         : val;
      // TransferLabel, IV1234567890, {... remaining QR Code contents}
      val = (val.substring(0, 8) === "TRANSFER")
         ? val.substring(15, 27)   // IV+10 digits
         : val;
      // ConsignedShipLabel, 123456789012, {... remaining QR Code contents}
      val = (val.substring(0, 9) === "CONSIGNED")
         ? val.substring(20, 32)   // 12 digits
         : val;
   }
   return val;
}

const GetPoundsFromKgs = (kg) => {
   return kg * 2.20462;
};

const INPUT_TYPES = {
   select: 1,
   checkbox: 2,
   text: 3,
   number: 4,
   checkboxANDInput: 5,
   typeAhead: 6,
   date: 7,
   radioButtonGroup: 8,
   button: 9,
};

const INVENTORY_TYPES = {
   rawMaterials: 1,
   finishedGoods: 2,
   packaging: 3,
};

const INVENTORYDASHBOARD_TYPES = {
   CurrentInventory: 1,
   Customers: 2,
   InventoryAdjustment: 3,
   InventoryTransfers: 4,
   InventoryVariance: 5,
   PurchasingActivity: 6,
   SalesActivity: 7,
   WhereUsed: 8,
};

const InventoryDashboardSectionHeaders = [
   {
      displayName: "Item:",
      onclick: true,
      value: null,
      label: "ddlText",
      className: "boldedOrange cursor-pointer",
      col: 1,
   },
   {
      displayName: "Item Class:",
      value: null,
      label: "itemClass",
      col: 1,
   },
   {
      displayName: "ABC Code:",
      value: null,
      label: "abcDisplayCode",
      col: 1,
   },
   {
      displayName: "Current Cost:",
      value: null,
      label: "currentCost",
      col: 1,
   },
   {
      displayName: "Standard Cost:",
      value: null,
      label: "standardCost",
      col: 1,
   },
   {
      displayName: "Alternate Item 1:",
      value: null,
      label: "alternateItem1",
      className: "boldedOrange cursor-pointer",
      col: 1,
   },
   {
      displayName: "Alternate Item 2:",
      value: null,
      label: "alternateItem2",
      className: "boldedOrange cursor-pointer",
      col: 1,
   },
   {
      displayName: "Vendor:",
      value: null,
      className: "boldedOrange cursor-pointer",
      label: "vendorIdWithName",
      col: 2,
   },
   {
      displayName: "Vendor Item Number:",
      value: null,
      label: "vendorItemNumber",
      col: 2,
   },
   {
      displayName: "Vendor Item Description:",
      value: null,
      label: "vendorItemDescription",
      col: 2,
   },
   {
      displayName: "Average Lead Time:",
      value: null,
      label: "averageLeadDays",
      col: 2,
      calculate: true,
   },
   {
      displayName: "Tare Weight:",
      value: null,
      label: "tareWeight",
      col: 2,
   },
   {
      displayName: "QC Hold",
      value: null,
      label: "qcHold",
      col: 2,
   },
];

const InventoryStockStatusInitialState = {
   itemNumber: true,
   itemDescriptionPartial: false,
   itemNumberText: { label: "--- All ---", value: "" },
   itemDescriptionPartialText: "",
   abcCodes: { label: "--- All ---", value: 0 },
   itemClasses: [],
   locations: [],
   showZeroQty: false,
   sortField: "ItemWithDescription",
   sortDirection: "asc",
   gridMode: 0,
};

const IsPositiveDecimal = (str) => {
   return /^[0-9]+(\.[0-9]+)?$/.test(str);
};

const IsPositiveNumber = (str) => {
   return (/^[0-9]+$/).test(str);
};

const ITEM_GROUP_LIST = [
   //{ value: 0, label: "Unknown" },
   { value: 1, label: "Chemical" },
   { value: 2, label: "Packaging" },
   { value: 3, label: "Yarn" },
];

const LocalStorageKeys = {
   CustomerDashboard: "CustomerDashboardFilters",
   SalesDashboard: "SalesDashboard",
   InventoryDashboard: "InventoryDashboard",
   Customer: "Customer",
};

const MACHINE_SETUP = {
   L861_FC: 1, // Leesona 861 FC Winder
   DS_21: 2, // Dietz-Schell Winder
   M50: 3, // Leesona M50 Winder
   OTHER: 4, // Temporary setup
   L861_TACK: 5, // Leesona 861 Tackified Winder
   L861_WAX: 6, // Leesona 861 Wax Winder
   DOUBLER: 7, // Gilbos Doubler
   VOLK: 8, // Volkmann VTS-06 Twister  (INACTIVE)
   TEXILMESA_L57_KS: 9, // Texilmesa L57 Kingspool Winder
   SAURER_TC2: 10, // Saurer Alma Technocorder TC2
   TAINING_35AFP: 11, // Taining 8 oz Winder
   TAINING_35AR: 12, // Taining 2.5 oz Winder
   SAHM: 13, // Sahm 230E
   SACO_RT: 14, // Saco Lowell Meadows Ring Twister
   UT60: 15, // UT50/60-733 Twister
   M50_WAX: 16, // Leesona M50 Wax Winder
   HW_COND: 17, // H-W ST4588  (INACTIVE)
   GRIFFIN_OVEN: 18, //   (INACTIVE)
   RATERA: 19, // Ratera 4PVU/330
   HACOBA: 20, // NSA-HS Style 41 Bobbins
   SSM_DP5: 21, // SSM DP5 Winder
   TAINING_35A_TUBE: 22, // Auto Tube Winder
   HACOBA_SMALL: 23, // NSA-U Small Bobbins Winder  (INACTIVE)
   LEZ_PIRN: 24, // Lezzini CLV Pirn Winder  (INACTIVE)
   RATTI_CU1: 25, // Ratti R325 CU1 Twister  (INACTIVE)
   OMM_KS: 26, // OMM D06KS Kingspool Winder  (INACTIVE)
   MAHAN_OVEN: 27,
   TAINING_S41: 28, // TN-09S Style 41 Bobbins
   HELI_KV2002: 29, // Pirn
   HELI_KV2008B: 30, // Twister
   TK_220_KS: 31, // TK-220 Kingspool Winder
   DS10E: 32, // DS10-E Winder
   RATTI_CU2: 33, // Ratti R325 CU2 Twister  (INACTIVE)
   TAINING_SB: 34, // TN-09S Small U Bobbins  (INACTIVE)
   HELI_KV2019B: 35, // Twister 2
   SSM_XENO: 36, // SSM Xeno Winder
   XORELLA: 37,
   SSM_DURO: 38,
};

const MACHINE_SETUP_ORDER_RANGE_LABELS = {
   CURRENT_WEEK: "Current Week",
   TWO_WEEKS: "Two Weeks",
   FOUR_WEEKS: "Four Weeks",
   SIX_WEEKS: "Six Weeks",
   EIGHT_WEEKS: "Eight Weeks",
   TWELVE_WEEKS: "Twelve Weeks",
};

const MACHINE_WORKORDER_LABOR_RATES = 105; // default MachineWorkOrderLaborRate

const MACHINE_WORKORDER_SITES = [
   { value: "PLTWHSE", label: "PLTWHSE - DANA ROAD" },
   { value: "KENM", label: "KENM" },
];

// The 2FA methods an account can be saved on (TypeOfMFA). Texted codes (2) were retired and are never offered.
const MFA_TYPES = [
   { label: "Duo", value: 1 },
   { label: "Authenticator app", value: 3 },
];

const MIME_TYPES = {
   csv: "text/csv",
   html: "text/html",
   pdf: "application/pdf",
   xls: "application/vnd.ms-excel",
   xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml",
};

const MOST_SOLD_REPORT_TYPES = [
   { value: 1, label: "Most Sold W/Order Breakdown" },
   { value: 2, label: "Most Sold W/Monthly Breakdown" },
   { value: 3, label: "Most Sold Summary View" },
];

const ORDER_TYPES = [
   { value: 0, label: "--- All ---" },
   { value: 2, label: "Sales Orders" },
   { value: 1, label: "Sample Orders" },
];

// Order/PlaceOrder per-group outcome codes - the names of TypeOfPlaceOrderOutcome, which the server
// serializes as strings. The message text comes from the server; only the toast style is chosen here.
const PLACE_ORDER_OUTCOME = {
   PLACED: "Placed",
   PLACED_WITH_WARNING: "PlacedWithWarning",
   REFUSED_BY_GP: "RefusedByGp",
   UNCONFIRMED: "Unconfirmed",
   NOT_PLACED: "NotPlaced",
};

const PINNED_TYPES = {
   DeskTop: { label: "Desktop or Laptop", value: 0, pinned: true },
   Mobile: { label: "Mobile or Handheld", value: 1, pinned: false },
   DeskTopUpinned: { label: "Desktop or Laptop", value: 0, pinned: false },
};

const PKG_TYPE = {
   UNKNOWN_MACHINE_PART: 0,
   CONE_TUBE_SPOOL: 1,
   BOX_DIVIDER: 2,
};

const PROCESS_CHANGE_APPROVER_TYPE_IDS = {
   FinalApprover: 0,
   MaintenanceEngineering: 1,
   ManufacturingOperations: 2,
   Quality: 3,
   Research: 4,
};

const PROCESS_CHANGE_TYPE_IDS = {
   Creel_Design_Or_Use: 100,
   Doubling: 200,
   Material_Handling_and_Storage: 300,
   Product_Packaging: 400,
   QC_Inspection: 500,
   Treating: 600,
   Twisting: 700,
   Winding: 800,
};

const PROVINCES = [
   "AB",
   "BC",
   "MB",
   "NB",
   "NT",
   "NS",
   "NU",
   "ON",
   "PE",
   "QC",
   "SK",
   "YT",
];

const READONLY_SELECT_STYLE = {
   dropdownIndicator: () => ({
      display: "none",
   }),
   indicatorSeparator: () => ({
      display: "none",
   }),
   control: (provided, _state) => ({
      ...provided,
      background: "transparent",
      borderColor: "transparent",
      width: "150px"
   }),
   singleValue: (provided) => ({
      ...provided,
      color: "#000",
   }),
};

const READONLY_SELECT_STYLE_WIDE = {
   dropdownIndicator: () => ({
      display: "none",
   }),
   indicatorSeparator: () => ({
      display: "none",
   }),
   control: (provided, _state) => ({
      ...provided,
      background: "transparent",
      borderColor: "transparent",
      width: "100%"
   }),
   singleValue: (provided) => ({
      ...provided,
      color: "#000",
   }),
};

const ResetInventoryStockStatus = {
   itemNumber: true,
   itemDescriptionPartial: false,
   itemNumberText: "",
   itemDescriptionPartialText: "",
   abcCodes: { label: "--- All ---", value: 0 },
   itemClasses: { label: "--- SELECT MULTIPLE ---", value: [] },
   locations: { label: "--- SELECT MULTIPLE ---", value: [] },
   showZeroQty: false,
};

const ROLE_IDS = {
   Admin: 1,
   CSREdit: 2,
   CSRView: 3,
   EngineeringEdit: 4,
   EngineeringView: 5,
   InventoryEdit: 6,
   InventoryView: 7,
   MaintenanceEdit: 8,
   MaintenanceView: 9,
   PowerUser: 10,
   ProductionControlEdit: 11,
   ProductionControlView: 12,
   PurchasingEdit: 13,
   PurchasingView: 14,
   QualityEdit: 15,
   QualityView: 16,
   Salesperson: 17,
   SalesEdit: 18,
   SalesView: 19,
   SewingTech: 20,
   WarehouseEdit: 21,
   WarehouseView: 22,
   Customer: 23,
   ConsignedCustomer: 24,
   MachinePartsCustomer: 25,
   HREdit: 26,
   HRView: 27,
   MachineOperator: 28,
};

// The customer-facing roles. A user holding any of these is scoped to their assigned customer account(s),
// so the User screen requires a customer number for them (server enforces the same rule on save).
const CUSTOMER_ROLE_IDS = [
   ROLE_IDS.Customer,
   ROLE_IDS.ConsignedCustomer,
   ROLE_IDS.MachinePartsCustomer,
];

// The staff roles that may see our cost, margin and markup on a screen customers or other staff can also reach.
// Mirrors AppHelpers.CostAndMarginRoles on the server, which blanks those values for everyone else - change both.
const COST_AND_MARGIN_ROLE_IDS = [
   ROLE_IDS.Admin,
   ROLE_IDS.PowerUser,
   ROLE_IDS.CSREdit,
   ROLE_IDS.CSRView,
   ROLE_IDS.PurchasingEdit,
   ROLE_IDS.SalesEdit,
   ROLE_IDS.Salesperson,
   ROLE_IDS.SewingTech,
];

const ROLE_NAMES = {
   Admin: "Admin",
   CSREdit: "CSR Edit",
   CSRView: "CSR View",
   EngineeringEdit: "Engineering Edit",
   EngineeringView: "Engineering View",
   InventoryEdit: "Inventory Edit",
   InventoryView: "Inventory View",
   MaintenanceEdit: "Maintenance Edit",
   MaintenanceView: "Maintenance View",
   PowerUser: "Power User",
   ProductionControlEdit: "Production Control Edit",
   ProductionControlView: "Production Control View",
   PurchasingEdit: "Purchasing Edit",
   PurchasingView: "Purchasing View",
   QualityEdit: "Quality Edit",
   QualityView: "Quality View",
   Salesperson: "Salesperson",
   SalesEdit: "Sales Edit",
   SalesView: "Sales View",
   SewingTech: "Sewing Tech",
   WarehouseEdit: "Warehouse Edit",
   WarehouseView: "Warehouse View",
   Customer: "Customer",
   ConsignedCustomer: "Consigned Customer",
   MachinePartsCustomer: "Machine Parts Customer",
   HREdit: "HR Edit",
   HRView: "HR View",
   MachineOperator: "Machine Operator",
};

const ROLE_DICTIONARY = {
   1: ROLE_NAMES.Admin,
   2: ROLE_NAMES.CSREdit,
   3: ROLE_NAMES.CSRView,
   4: ROLE_NAMES.EngineeringEdit,
   5: ROLE_NAMES.EngineeringView,
   6: ROLE_NAMES.InventoryEdit,
   7: ROLE_NAMES.InventoryView,
   8: ROLE_NAMES.MaintenanceEdit,
   9: ROLE_NAMES.MaintenanceView,
   10: ROLE_NAMES.PowerUser,
   11: ROLE_NAMES.ProductionControlEdit,
   12: ROLE_NAMES.ProductionControlView,
   13: ROLE_NAMES.PurchasingEdit,
   14: ROLE_NAMES.PurchasingView,
   15: ROLE_NAMES.QualityEdit,
   16: ROLE_NAMES.QualityView,
   17: ROLE_NAMES.Salesperson,
   18: ROLE_NAMES.SalesEdit,
   19: ROLE_NAMES.SalesView,
   20: ROLE_NAMES.SewingTech,
   21: ROLE_NAMES.WarehouseEdit,
   22: ROLE_NAMES.WarehouseView,
   23: ROLE_NAMES.Customer,
   24: ROLE_NAMES.ConsignedCustomer,
   25: ROLE_NAMES.MachinePartsCustomer,
   26: ROLE_NAMES.HREdit,
   27: ROLE_NAMES.HRView,
   28: ROLE_NAMES.MachineOperator,
};

const ALL_ROLES = [
   {
      value: ROLE_IDS.Admin,
      label: ROLE_NAMES.Admin,
      groupName: "Admin",
   },
   {
      value: ROLE_IDS.CSREdit,
      label: ROLE_NAMES.CSREdit,
      groupName: "CSR",
   },
   {
      value: ROLE_IDS.CSRView,
      label: ROLE_NAMES.CSRView,
      groupName: "CSR",
   },
   {
      value: ROLE_IDS.EngineeringEdit,
      label: ROLE_NAMES.EngineeringEdit,
      groupName: "Engineering",
   },
   {
      value: ROLE_IDS.EngineeringView,
      label: ROLE_NAMES.EngineeringView,
      groupName: "Engineering",
   },
   {
      value: ROLE_IDS.HREdit,
      label: ROLE_NAMES.HREdit,
      groupName: "HR",
   },
   {
      value: ROLE_IDS.HRView,
      label: ROLE_NAMES.HRView,
      groupName: "HR",
   },
   {
      value: ROLE_IDS.InventoryEdit,
      label: ROLE_NAMES.InventoryEdit,
      groupName: "Inventory",
   },
   {
      value: ROLE_IDS.InventoryView,
      label: ROLE_NAMES.InventoryView,
      groupName: "Inventory",
   },
   {
      value: ROLE_IDS.MachineOperator,
      label: ROLE_NAMES.MachineOperator,
      groupName: "Operator",
   },
   {
      value: ROLE_IDS.MaintenanceEdit,
      label: ROLE_NAMES.MaintenanceEdit,
      groupName: "Maintenance",
   },
   {
      value: ROLE_IDS.MaintenanceView,
      label: ROLE_NAMES.MaintenanceView,
      groupName: "Maintenance",
   },
   {
      value: ROLE_IDS.PowerUser,
      label: ROLE_NAMES.PowerUser,
      groupName: "PowerUser",
   },
   {
      value: ROLE_IDS.ProductionControlEdit,
      label: ROLE_NAMES.ProductionControlEdit,
      groupName: "Production",
   },
   {
      value: ROLE_IDS.ProductionControlView,
      label: ROLE_NAMES.ProductionControlView,
      groupName: "Production",
   },
   {
      value: ROLE_IDS.PurchasingEdit,
      label: ROLE_NAMES.PurchasingEdit,
      groupName: "Purchasing",
   },
   {
      value: ROLE_IDS.PurchasingView,
      label: ROLE_NAMES.PurchasingView,
      groupName: "Purchasing",
   },
   {
      value: ROLE_IDS.QualityEdit,
      label: ROLE_NAMES.QualityEdit,
      groupName: "Quality",
   },
   {
      value: ROLE_IDS.QualityView,
      label: ROLE_NAMES.QualityView,
      groupName: "Quality",
   },
   {
      value: ROLE_IDS.Salesperson,
      label: ROLE_NAMES.Salesperson,
      groupName: "Salesperon",
   },
   {
      value: ROLE_IDS.SalesEdit,
      label: ROLE_NAMES.SalesEdit,
      groupName: "Sales",
   },
   {
      value: ROLE_IDS.SalesView,
      label: ROLE_NAMES.SalesView,
      groupName: "Sales",
   },
   {
      value: ROLE_IDS.SewingTech,
      label: ROLE_NAMES.SewingTech,
      groupName: "SewingTech",
   },
   {
      value: ROLE_IDS.WarehouseEdit,
      label: ROLE_NAMES.WarehouseEdit,
      groupName: "Warehouse",
   },
   {
      value: ROLE_IDS.WarehouseView,
      label: ROLE_NAMES.WarehouseView,
      groupName: "Warehouse",
   },
   {
      value: ROLE_IDS.Customer,
      label: ROLE_NAMES.Customer,
      groupName: "Customer",
   },
   {
      value: ROLE_IDS.ConsignedCustomer,
      label: ROLE_NAMES.ConsignedCustomer,
      groupName: "Customer",
   },
   {
      value: ROLE_IDS.MachinePartsCustomer,
      label: ROLE_NAMES.MachinePartsCustomer,
      groupName: "Customer",
   },
];

const SALES_CALL_TRACKING_ACTION_TYPES = {
   Phone: 1,
   Onsite: 2,
   Email: 3,
   Fax: 4,
   None: -1,
};

const SCHEDULED_MAINTENANCE = "Scheduled Maintenance";

const SHIPPING_CLASS = {
   A: "A",
   B: "B",
   C: "C",
};

const SHIPPING_SCHEDULE_TYPES = {
   AllShipping: 0,
   MachinePartShipping: 1,
   DropShipping: 2,
};

const SORTING_STATE_INVENTORY_DASHBOARD = {
   selectedItem: null,
   getAll: true,
   typeOfDataSource: 0,
   currentInvSortDirection: "asc",
   currentInvSortField: "",
   customersSortDirection: "asc",
   customersSortField: "",
   invTraSortDirection: "asc",
   invTraSortField: "",
   invVarSortDirection: "asc",
   invVarSortField: "",
   purchActivitySortDirection: "asc",
   purchActivitySortField: "",
   days: -5,
   limitRows: true,
};

const SPEC_TYPE_LIST = {
   FinishedGoods: 1,
   SpecWithTestResults: 2,
   PurchasedMaterial: 3,
   All: 4,
   InProcessBulk: 5,
   // Sample: 3
};

const STATE_LIST = [
   { label: "--- Select State ---", value: "-1" },
   { label: "Alabama", value: "AL" },
   { label: "Alaska", value: "AK" },
   { label: "American Samoa", value: "AS" },
   { label: "Arizona", value: "AZ" },
   { label: "Arkansas", value: "AR" },
   { label: "California", value: "CA" },
   { label: "Colorado", value: "CO" },
   { label: "Connecticut", value: "CT" },
   { label: "Delaware", value: "DE" },
   { label: "District of Columbia", value: "DC" },
   { label: "Federated States of Micronesia", value: "FSM" },
   { label: "Florida", value: "FL" },
   { label: "Georgia", value: "GA" },
   { label: "Guam", value: "GU" },
   { label: "Hawaii", value: "HI" },
   { label: "Idaho", value: "ID" },
   { label: "Illinois", value: "IL" },
   { label: "Indiana", value: "IN" },
   { label: "Iowa", value: "IA" },
   { label: "Kansas", value: "KS" },
   { label: "Kentucky", value: "KY" },
   { label: "Louisiana", value: "LA" },
   { label: "Maine", value: "ME" },
   { label: "Marshall Islands", value: "MH" },
   { label: "Maryland", value: "MD" },
   { label: "Massachusetts", value: "MA" },
   { label: "Michigan", value: "MI" },
   { label: "Minnesota", value: "MN" },
   { label: "Mississippi", value: "MS" },
   { label: "Missouri", value: "MO" },
   { label: "Montana", value: "MT" },
   { label: "Nebraska", value: "NE" },
   { label: "Nevada", value: "NV" },
   { label: "New Hampshire", value: "NH" },
   { label: "New Jersey", value: "NJ" },
   { label: "New Mexico", value: "NM" },
   { label: "New York", value: "NY" },
   { label: "North Carolina", value: "NC" },
   { label: "North Dakota", value: "ND" },
   { label: "Northern Mariana Islands", value: "CNMI" },
   { label: "Ohio", value: "OH" },
   { label: "Oklahoma", value: "OK" },
   { label: "Oregon", value: "OR" },
   { label: "Palau", value: "PW" },
   { label: "Pennsylvania", value: "PA" },
   { label: "Puerto Rico", value: "PR" },
   { label: "Rhode Island", value: "RI" },
   { label: "South Carolina", value: "SC" },
   { label: "South Dakota", value: "SD" },
   { label: "Tennessee", value: "TN" },
   { label: "Texas", value: "TX" },
   { label: "Utah", value: "UT" },
   { label: "Vermont", value: "VT" },
   { label: "Virgin Islands", value: "VI" },
   { label: "Virginia", value: "VA" },
   { label: "Washington", value: "WA" },
   { label: "West Virginia", value: "WV" },
   { label: "Wisconsin", value: "WI" },
   { label: "Wyoming", value: "WY" },
];

const STATES = [
   "AK",
   "AL",
   "AR",
   "AZ",
   "CA",
   "CO",
   "CT",
   "DC",
   "DE",
   "FL",
   "GA",
   "HI",
   "IA",
   "ID",
   "IL",
   "IN",
   "KS",
   "KY",
   "LA",
   "MA",
   "MD",
   "ME",
   "MI",
   "MN",
   "MO",
   "MS",
   "MT",
   "NC",
   "ND",
   "NE",
   "NH",
   "NJ",
   "NM",
   "NV",
   "NY",
   "OH",
   "OK",
   "OR",
   "PA",
   "RI",
   "SC",
   "SD",
   "TN",
   "TX",
   "UT",
   "VA",
   "VT",
   "WA",
   "WI",
   "WV",
   "WY",
];

const STOCK_CLASS_LIST = [
   { value: "FG", label: "Finished Good" },
   { value: "IP", label: "In Process" },
   { value: "PM", label: "Purchased Material" },
   { value: "N/A", label: "Not Applicable" },
];

const StockStatusFieldObjects = [
   {
      name: "Item Number:",
      type: INPUT_TYPES.checkboxANDInput,
      label: "itemNumber",
      textValue: "",
      value: null,
      typeAhead: true,
   },
   {
      name: "Item Description Partial:",
      type: INPUT_TYPES.checkboxANDInput,
      label: "itemDescriptionPartial",
      textValue: "",
      value: null,
   },
   {
      name: "ABC Code: ",
      type: INPUT_TYPES.select,
      label: "abcCodes",
      value: null,
      options: [],
   },
   {
      name: "Class: ",
      type: INPUT_TYPES.select,
      label: "itemClasses",
      value: null,
      options: [],
      isMulti: true,
   },
   {
      name: "Site: ",
      type: INPUT_TYPES.select,
      label: "locations",
      value: null,
      options: [],
      isMulti: true,
   },
   {
      name: "Zero On Hand: ",
      type: INPUT_TYPES.checkbox,
      label: "showZeroQty",
      value: null,
      desc: "Show items with NO on hand quantity?",
   },
];

const StockStatusGridModes = {
   viewData: 1,
   edit: 2,
};

const StockStatusViewPayload = {
   ItemNumber: "",
   ItemDescription: "",
   ABCCode: 0,
   ClassList: [],
   SiteList: [],
   ShowZeroQty: false,
};

const THEMES = {
   darkTheme: {
      label: "darkTheme",
      value: 2,
   },
   lightTheme: {
      label: "lightTheme",
      value: 1,
   },
   default: {
      label: "lightTheme",
      value: 1,
   },
};

// const TIME_CODES = {
// Absent: 1,
// EarlyOutLeftEarly: 2,
// Late: 3,
// };

const TIMERS = {
   fifteenSeconds: 15000,
   fiveMinutes: 300000,
   twentyMinutes: 1200000,
   twentyFiveMinutes: 1500000,
   thirtyMinutes: 1800000,
   oneHundredFifteenMinutes: 7200000,
};

const TYPE_AHEAD_CLASSES = {
   CustomerList: 0,
   SalesCallList: 1,
   MachineParts: 2,
   RawMaterials: 3,
   VendorList: 4,
   SpecificationItems: 5,
   SpecificationItemsWithSamples: 6,
   SpecificationItemsWithTestData: 7,
   BOMItems: 8,
   BOMItemsWithSamples: 9,
   BOMYarnComponents: 10,
   BOMPackagingComponents: 11,
   BOMChemicalComponents: 12,
   InventoryItems: 13,
   InventoryItemsWithSamples: 14,
   PurchasedMaterials: 15,
   SampleItemRequests: 16,
   SpecItemsForSampleReference: 17,
   SpecItemsWithAllActiveSamples: 18,
   BOMYarnComponentsWithSamples: 19,
   BOMPackagingComponentsWithSamples: 20,
   BOMChemicalComponentsWithSamples: 21,
};

const UNBOUNDED_RESULT_ROW_COUNT = {
   label: "100000",
   value: 100000,
};

const UOM_LIST = [
   { value: "EA", label: "EA" },
   { value: "LBS", label: "LBS" },
];

const VALID_ORDER_SITES = ["PLT", "PLTWHSE", "FLEX05"];

const WITH_ROLES_INVENTORYDASHBOARD_SWITCHES = [
   {
      name: "General",
      type: INPUT_TYPES.button,
      label: "generalInformation",
      value: false,
      col: 3,
      rightSide: true,
      colSize: "1",
      access: [],
      accesss: [],
   },
   {
      name: "INVENTORY",
      type: INPUT_TYPES.button,
      label: "currentInventory",
      value: true,
      col: 1,
      rightSide: true,
      colSize: "1",
      accesss: [],
   },
   {
      name: "PURCHASING",
      type: INPUT_TYPES.button,
      label: "purchasingActivity",
      value: true,
      col: 1,
      rightSide: true,
      colSize: "1",
      accesss: [
         ROLE_IDS.Admin,
         ROLE_IDS.PowerUser,
         ROLE_IDS.PurchasingEdit,
         ROLE_IDS.PurchasingView,
      ],
   },
   {
      name: "PM NEEDS",
      type: INPUT_TYPES.button,
      label: "purchasingNeeds",
      value: true,
      col: 1,
      rightSide: true,
      colSize: "1",
      accesss: [
         ROLE_IDS.Admin,
         ROLE_IDS.PowerUser,
         ROLE_IDS.PurchasingEdit,
         ROLE_IDS.PurchasingView,
      ],
   },
   {
      name: "SALES",
      type: INPUT_TYPES.button,
      label: "salesActivity",
      value: true,
      col: 1,
      rightSide: true,
      colSize: "1",
      accesss: [
         ROLE_IDS.Admin,
         ROLE_IDS.PowerUser,
         ROLE_IDS.PurchasingEdit,
         ROLE_IDS.PurchasingView,
         ROLE_IDS.CSREdit,
         ROLE_IDS.CSRView,
         ROLE_IDS.Salesperson,
         ROLE_IDS.SalesEdit,
         ROLE_IDS.SalesView,
      ],
   },
   {
      name: "TRANSFERS",
      type: INPUT_TYPES.button,
      label: "inventoryTransfers",
      value: true,
      col: 2,
      rightSide: true,
      colSize: "1",
      accesss: [],
   },
   {
      name: "VARIANCES",
      type: INPUT_TYPES.button,
      label: "inventoryVariance",
      value: true,
      col: 2,
      rightSide: true,
      colSize: "1",
      accesss: [],
   },
   {
      name: "CUSTOMERS",
      type: INPUT_TYPES.button,
      label: "customers",
      value: true,
      col: 2,
      rightSide: true,
      colSize: "1",
      accesss: [
         ROLE_IDS.Admin,
         ROLE_IDS.PowerUser,
         ROLE_IDS.PurchasingEdit,
         ROLE_IDS.PurchasingView,
         ROLE_IDS.CSREdit,
         ROLE_IDS.CSRView,
         ROLE_IDS.Salesperson,
         ROLE_IDS.SalesEdit,
         ROLE_IDS.SalesView,
      ],
   },
   {
      name: "ADJUSTMENTS",
      type: INPUT_TYPES.button,
      label: "inventoryAdjustments",
      value: true,
      col: 3,
      rightSide: true,
      colSize: "1",
      accesss: [],
   },
   {
      name: "WHERE USED",
      type: INPUT_TYPES.button,
      label: "whereUsed",
      value: true,
      col: 3,
      rightSide: true,
      colSize: "1",
      accesss: [],
   },
];

const WITH_ROLES_INVENTORYDASHBOARD_SCREENSWITCHES = {
   generalInformation: {
      showing: false,
      access: [],
   },
   currentInventory: {
      showing: false,
      access: [],
   },
   purchasingActivity: {
      showing: false,
      access: [
         ROLE_IDS.Admin,
         ROLE_IDS.PowerUser,
         ROLE_IDS.PurchasingEdit,
         ROLE_IDS.PurchasingView,
      ],
   },
   purchasingNeeds: {
      showing: false,
      access: [
         ROLE_IDS.Admin,
         ROLE_IDS.PowerUser,
         ROLE_IDS.PurchasingEdit,
         ROLE_IDS.PurchasingView,
      ],
   },
   salesActivity: {
      showing: false,
      access: [
         ROLE_IDS.Admin,
         ROLE_IDS.PowerUser,
         ROLE_IDS.PurchasingEdit,
         ROLE_IDS.PurchasingView,
         ROLE_IDS.CSREdit,
         ROLE_IDS.CSRView,
         ROLE_IDS.Salesperson,
         ROLE_IDS.SalesEdit,
         ROLE_IDS.SalesView,
      ],
   },
   inventoryTransfers: {
      showing: false,
      access: [],
   },
   inventoryVariance: {
      showing: false,
      access: [],
   },
   customers: {
      showing: false,
      access: [
         ROLE_IDS.Admin,
         ROLE_IDS.PowerUser,
         ROLE_IDS.PurchasingEdit,
         ROLE_IDS.PurchasingView,
         ROLE_IDS.CSREdit,
         ROLE_IDS.CSRView,
         ROLE_IDS.Salesperson,
         ROLE_IDS.SalesEdit,
         ROLE_IDS.SalesView,
      ],
   },
   inventoryAdjustments: {
      showing: false,
      access: [],
   },
   whereUsed: {
      showing: false,
      access: [],
   },
};

const constants = {
   ABC_CODE,
   ABC_CODE_LIST,
   ALL_ITEM: { label: "--- All ---", value: "" },
   ALL_ROLES,
   ATTACHMENT_TYPES,
   AUTO_NUMS_TYPE,
   BARCODE_TYPE,
   BOM_GROUP,
   //BOM_TYPEAHEAD_TYPE,
   BREAKPOINTS,
   C_MAX_INT: 2147483647,
   CALCULATION_TYPES,
   COLOR_OPTIONS,
   CONSIGN_BARCODE_LEN,
   CORRECTIVE_ACTION_STATUSES,
   CORRECTIVE_ACTION_STATUSES_SELECT,
   CORRECTIVE_ACTION_TYPES,
   CORRECTIVE_ACTION_TYPES_NEW,
   CORRECTIVE_ACTION_TYPES_SEARCH,
   COST_AND_MARGIN_ROLE_IDS,
   COUNTRY_LIST,
   CUSTOMER_ROLE_IDS,
   DATA_TYPES,
   DATE_RANGE_TYPE,
   DEFAULT_TIMEZONE: "Eastern Standard Time",
   MAX_CUSTOMER_ACCOUNTS: 5, // a customer-role user may be assigned 1..5 accounts (mirrors AppConstants)
   DEVICE_TYPES,
   DOCUMENT_TYPES,
   DUO_ID: 1,
   ENDPOINTS,
   FINISHED_GOOD_CLASS_CODES,
   FIVE_MINUTES_MS: 300000,
   flipCheckBox,
   GenViewDataPayLoad,
   GetBarcodeType,
   GetProperCaseWord,
   GetRealBarcode,
   GetPoundsFromKgs,
   INDUSTRY_TYPES: [
      { value: "Bag Packaging", label: "Bag Packaging" },
      { value: "Hose", label: "Hose" },
      { value: "Sling", label: "Sling" },
      { value: "Wire and Cabel", label: "Wire and Cabel" },
      { value: "Other", label: "Other" },
   ],
   INPUT_TYPES,
   Is_Each: ["ARAMIDEA", "FILA-EA", "SPUN-EA", "TREAT- EA"],
   IsPositiveDecimal,
   IsPositiveNumber,
   INVENTORY_TYPES,
   INVENTORYDASHBOARD_TYPES,
   InventoryDashboardSectionHeaders,
   InventoryStockStatusInitialState,
   ITEM_GROUP_LIST,
   LEGACY_APP_ROOT_URL: "https://st-test.servicethread.com",
   MACHINE_SETUP,
   MACHINE_WORKORDER_SITES,
   MFA_TYPES,
   MIME_CSV: "text/csv",
   MIME_PDF: "application/pdf",
   MIME_TYPES,
   MIME_XLS: "application/vnd.ms-excel",
   MIME_XLSX: "application/vnd.openxmlformats-officedocument.spreadsheetml",
   MONTHS: [
      { value: 1, label: "January" },
      { value: 2, label: "February" },
      { value: 3, label: "March" },
      { value: 4, label: "April" },
      { value: 5, label: "May" },
      { value: 6, label: "June" },
      { value: 7, label: "July" },
      { value: 8, label: "August" },
      { value: 9, label: "September" },
      { value: 10, label: "October" },
      { value: 11, label: "November" },
      { value: 12, label: "December" },
   ],
   LocalStorageKeys: LocalStorageKeys,
   MACHINE_SETUP_ORDER_RANGE_LABELS: MACHINE_SETUP_ORDER_RANGE_LABELS,
   MACHINE_WORKORDER_LABOR_RATES: MACHINE_WORKORDER_LABOR_RATES,
   MOST_SOLD_REPORT_TYPES,
   // inventory.MoveOrder.StartedOn for an order the new /m app created (AppConstants.MoveOrders.StartedOnMobile) - change both together.
   MOVE_ORDER_STARTED_ON_MOBILE: "Mobile",
   ORDER_TYPES,
   PART_NUMBER_TYPES: {
      NA: { value: 1, label: "Not Applicable" },
      VARIOUS: { value: 2, label: "Various" },
      SELECTED: { value: 3, label: "Select Item(s)" },
   },
   PASSWORD_COMPLEXITY_DESCRIPTION:
      "Passwords must be at least 8 characters long and contain at least 1 uppercase character, at least 1 lowercase character and at least 1 number.",
   PKG_TYPE,
   PINNED_TYPES,
   PLACE_ORDER_OUTCOME,
   // The start of the server's refusal when another post of the same PO holds the receipt lock
   // (AppConstants.ReceivePo.LegacyPostInProgress) - change both together. The receive screens show it as is, never
   // as an override prompt: the override post would meet the same lock.
   PO_RECEIPT_IN_PROGRESS: "Another post for this PO is already in progress",
   // The start of every PostReceipt / PostAdminReceipt catch-block failure (MobileController: AppConstants.ErrorMessages.Prefix
   // + " Log #") - change both together. The receive screens toast it; only a data refusal may reach the override prompt.
   PO_RECEIPT_POST_FAULT: "ERROR: Log #",
   PRINT_QTY_OPTIONS: _.chain(_.range(11)) // 0-10
      .map((p) => ({ label: p, value: p }))
      .sortBy((x) => {
         return x.label;
      })
      .value(),
   PRINTER_TYPES: {
      LABEL: { value: 1, label: "Label" },
      LASER: { value: 2, label: "Laser" },
      PARTS: { value: 3, label: "Parts" },
   },
   PROCESS_CHANGE_TYPE_IDS,
   PROCESS_CHANGE_APPROVER_TYPE_IDS,
   PROVINCES: _.chain(PROVINCES)
      .map((p) => ({ label: p, value: p }))
      .sortBy((x) => {
         return x.label;
      })
      .value(),
   READONLY_SELECT_STYLE,
   READONLY_SELECT_STYLE_WIDE,
   ResetInventoryStockStatus,
   ROLE_DICTIONARY,
   ROLE_IDS,
   ROLE_NAMES,
   SALES_CALL_TRACKING_ACTION_TYPES,
   SAVINGS_TYPES: {
      ANNUAL: { value: 1, label: "Annual" },
      ONE_TIME: { value: 2, label: "One Time" },
   },
   SCHEDULED_MAINTENANCE,
   SORTING_STATE_INVENTORY_DASHBOARD,
   SHIPPING_CLASS,
   SHIPPING_SCHEDULE_TYPES,
   SPEC_TYPE_LIST,
   STATES: _.chain(STATES)
      .map((s) => ({ label: s, value: s }))
      .sortBy((x) => {
         return x.label;
      })
      .value(),
   STATE_LIST,
   STOCK_CLASS_LIST,
   StockStatusFieldObjects,
   StockStatusGridModes,
   StockStatusViewPayload,
   TYPE_AHEAD_CLASSES,
   TestingSpec: {
      absorbCapacityMax: 0,
      absorbCapacityMin: 0,
      absorbCapacityNom: 0,
      absorbSpeedMax: 0,
      absorbSpeedMin: 0,
      absorbSpeedNom: 0,
      appSuppliers: "",
      appearance: "",
      astmD5118Note: "",
      attachmentCount: 0,
      bulkItemNumber: "",
      calAbsorbCapacity: false,
      calAbsorbSpeed: false,
      calAstmD5118: false,
      calEASL: false,
      calElong: true,
      calFinish: false,
      calFirstTwist: true,
      calGauge: false,
      calLase05: false,
      calLase10: false,
      calModulus: false,
      calPH: false,
      calPackDiameter: true,
      calPackWeight: true,
      calPkgBaseDia: false,
      calPkgHeight: false,
      calPkgInnerDia: false,
      calPkgLength: false,
      calPkgMaterialType: false,
      calPkgOther: false,
      calPkgOuterDia: false,
      calPkgTipDia: false,
      calPkgWall: false,
      calPkgWeightRating: false,
      calPkgWidth: false,
      calQCT1: true,
      calQCT2: true,
      calQCT3: false,
      calQCT4: true,
      calQCT5: false,
      calQCT6: false,
      calQCT7: false,
      calQCT8: false,
      calQCT11: false,
      calQCT12: false,
      calQCT13: false,
      calQCT14: false,
      calRefrIdx: false,
      calSecondTwist: false,
      calShoreDurometer: true,
      calShrinkage: false,
      calSolids: false,
      calSpecGrav: false,
      calSwellingFactor: false,
      calTenacity: true,
      calViscosity: false,
      calYield: true,
      customerId: "",
      customerItemDescription: null,
      customerItemNumber: null,
      easlMax: 0,
      easlMin: 0,
      easlNom: 0,
      elongMax: 15.5,
      elongMin: 10.5,
      elongNom: 13,
      filamentCount: 192,
      finishMax: 0,
      finishMin: 0,
      finishNom: 0,
      firstTwistDirection: "this is what is happening",
      firstTwistMax: 1.5,
      firstTwistMaxTPM: 60,
      firstTwistMin: 0.25,
      firstTwistMinTPM: 10,
      firstTwistNom: 1.25,
      firstTwistNomTPM: 50,
      gaugeMax: 0,
      gaugeMaxMM: 0,
      gaugeMin: 0,
      gaugeMinMM: 0,
      gaugeNom: 0,
      gaugeNomMM: 0,
      holdComment: "",
      holdFollowUp: null,
      holdInitials: "",
      holdReason: "",
      holdReasonId: 0,
      instructions: "Customer requires WO# on line #3 on cone label\r\nWO# on Cone Label MUST match Master Label, PL and COA",
      isChemClass: false,
      isCottonClass: false,
      isCottonSpec: false,
      isDenierClass: true,
      isDenierSpec: true,
      isFinishedGoodClass: true,
      isInProcessClass: false,
      isPkgClass: false,
      isPurchasedMaterialClass: false,
      isSpecAllowedClass: true,
      itemClass: "FILA-EA",
      itemDescription: "P1000.Z060.5.75",
      itemNumber: "FG00154",
      itemType: 1,
      itemWithDesc: "FG00154 | P1000.Z060.5.75",
      labelLine1: "P1-1000-121-PTP-C",
      labelLine2: "",
      labelLine3: "WO-00379549-1",
      labelLine4: "Service Thread",
      labelRequired: true,
      labelTemp: "",
      lase05Max: 0,
      lase05Min: 0,
      lase05Nom: 0,
      lase10Max: 0,
      lase10Min: 0,
      lase10Nom: 0,
      machineSetupList: null,
      maxSplices: 3,
      modulusMin: 0,
      modulusNom: 0,
      needleSize: 0,
      needleSizeDescription: "",
      numEnds: 1,
      onHold: false,
      onHoldDate: null,
      packDiaMax: 5.7,
      packDiaMaxCM: 14.478,
      packDiaMin: 5.43,
      packDiaMinCM: 13.7922,
      packDiaNom: 5.57,
      packDiaNomCM: 14.1478,
      packLbsMax: 4.17,
      packLbsMaxKG: 1.8914801829,
      packLbsMin: 3.93,
      packLbsMinKG: 1.7826180141,
      packLbsNom: 4.05,
      packLbsNomKG: 1.8370490985,
      packTraverse: 6,
      phMax: 0,
      phMin: 0,
      phNom: 0,
      pkgBaseDiaMax: 0,
      pkgBaseDiaMaxMM: 0,
      pkgBaseDiaMin: 0,
      pkgBaseDiaMinMM: 0,
      pkgBaseDiaNom: 0,
      pkgBaseDiaNomMM: 0,
      pkgHeightMax: 0,
      pkgHeightMaxMM: 0,
      pkgHeightMin: 0,
      pkgHeightMinMM: 0,
      pkgHeightNom: 0,
      pkgHeightNomMM: 0,
      pkgInnerDiaMax: 0,
      pkgInnerDiaMaxMM: 0,
      pkgInnerDiaMin: 0,
      pkgInnerDiaMinMM: 0,
      pkgInnerDiaNom: 0,
      pkgInnerDiaNomMM: 0,
      pkgLengthMax: 0,
      pkgLengthMaxMM: 0,
      pkgLengthMin: 0,
      pkgLengthMinMM: 0,
      pkgLengthNom: 0,
      pkgLengthNomMM: 0,
      pkgMaterialType: "",
      pkgOther: "",
      pkgOuterDiaMax: 0,
      pkgOuterDiaMaxMM: 0,
      pkgOuterDiaMin: 0,
      pkgOuterDiaMinMM: 0,
      pkgOuterDiaNom: 0,
      pkgOuterDiaNomMM: 0,
      pkgTipDiaMax: 0,
      pkgTipDiaMaxMM: 0,
      pkgTipDiaMin: 0,
      pkgTipDiaMinMM: 0,
      pkgTipDiaNom: 0,
      pkgTipDiaNomMM: 0,
      pkgWallMax: 0,
      pkgWallMaxMM: 0,
      pkgWallMin: 0,
      pkgWallMinMM: 0,
      pkgWallNom: 0,
      pkgWallNomMM: 0,
      pkgWeightRating: "",
      pkgWidthMax: 0,
      pkgWidthMaxMM: 0,
      pkgWidthMin: 0,
      pkgWidthMinMM: 0,
      pkgWidthNom: 0,
      pkgWidthNomMM: 0,
      printPalletCount: 0,
      printPalletCustPO: false,
      printPalletLabel: false,
      printPalletLotNumber: false,
      printPalletPart: false,
      printPalletPartDescription: false,
      putUpSize: 'Dk Blue / 7" 3-30 Cone',
      putUpType: "",
      qcT1Note: "",
      qcT2Note: "",
      qcT3Note: "",
      qcT4Note: "",
      qcT5Note: "",
      qcT6Note: "",
      qcT7Note: "",
      qcT8Note: "",
      qcT11Note: "",
      qcT12Note: "",
      qcT13Note: "",
      qcT14Note: "",
      refractiveIdxMax: 0,
      refractiveIdxMin: 0,
      refractiveIdxNom: 0,
      requiresBaseSpec: false,
      revDate: "2022-04-11T08:50:20.117",
      revNumber: 14,
      // revisionNotes
      // :
      // [{itemNumber: "FG00154 ", revDate: "2002-07-19T00:00:00",…},…]
      secondTwistDirection: "",
      secondTwistMax: 0,
      secondTwistMaxTPM: 0,
      secondTwistMin: 0,
      secondTwistMinTPM: 0,
      secondTwistNom: 0,
      secondTwistNomTPM: 0,
      shoreDurometerMax: 65,
      shoreDurometerMin: 45,
      shoreDurometerNom: 55,
      shrinkMax: 0,
      shrinkMin: 0,
      shrinkNom: 0,
      solidsMax: 0,
      solidsMin: 0,
      solidsNom: 0,
      specNumber: "FG00154",
      specType: "FG",
      specificGravityMax: 0,
      specificGravityMin: 0,
      specificGravityNom: 0,
      specificationType: 1,
      strengthMax: 20,
      strengthMin: 18.7,
      strengthMinKGS: 8.482177319,
      strengthMinKGSTotalEnds: 8.482177319,
      strengthMinN: 83.18174392,
      strengthMinNTotalEnds: 83.18174392,
      strengthMinTotalEnds: 18.7,
      strengthNom: 20.2,
      strengthNomKGS: 9.162565874,
      strengthNomKGSTotalEnds: 9.162565874,
      strengthNomN: 89.85407632,
      strengthNomNTotalEnds: 89.85407632,
      strengthNomTotalEnds: 20.2,
      swellingFactorMax: 0,
      swellingFactorMin: 0,
      swellingFactorNom: 0,
      tenacityMax: 8.93778069,
      tenacityMin: 8.16,
      tenacityMinDtex: 7.205176813016106,
      tenacityNom: 9.05,
      tenacityNomDtex: 7.9906823636115885,
      threadColor: "",
      transferTail: 0,
      vendorId: "",
      vendorItemDescription: "",
      vendorItemNumber: "",
      vendorItemWithName: "",
      vendorName: null,
      viscosityMax: 0,
      viscosityMin: 0,
      viscosityNom: 0,
      yarnJoinType: "Air Splice",
      yarnSizeMax: 1039.5,
      yarnSizeMaxDenier: 1039.5,
      yarnSizeMaxDtex: 1160,
      yarnSizeMaxTotalEnds: 1039.5,
      yarnSizeMaxTotelEndsDtex: 1160,
      yarnSizeMin: 985.5,
      yarnSizeMinDenier: 985.5,
      yarnSizeMinDtex: 1100,
      yarnSizeMinTotalEnds: 985.5,
      yarnSizeMinTotalEndsDtex: 1100,
      yarnSizeNom: 1012.5,
      yarnSizeNomDenier: 1012.5,
      yarnSizeNomDtex: 1130,
      yarnSizeNomTotalEnds: 1012.5,
      yarnSizeNomTotalEndsDtex: 1130,
      yarnSizeUnitOfMeasure: "Denier",
      yieldMax: 4530.19,
      yieldMaxTotalEnds: 4530.19,
      yieldMin: 4294.85,
      yieldMinTotalEnds: 4294.85,
      yieldNom: 4409.38,
      yieldNomTotalEnds: 4409.38,
   },
   TestingSupplierSpec: {
      actionBy: "keith McMillan",
      actionByTitle: "General Manager",
      actionDate: "2023-01-04T00:00:00",
      actionId: 420,
      actionType: 3,
      approvalComments: "Tube accepted.  Will not impact winding process for waxed products.",
      approvalDate: "2023-01-04T00:00:00",
      approvedBy: "Jeff Aiken",
      attachmentType: 11,
      attention: "Keith McMillan",
      createdDate: "2023-01-04T00:00:00",
      creditAmount: 0,
      creditRequested: false,
      displayId: "SCAR2023-420",
      itemType: "PM01701",
      itemWithDesc: "PM01701 | 4.15L TUBE",
      longTerm: "No response required.",
      lotNumber: "NA",
      originator: "Jeff Aiken",
      poNumber: "PO20221685",
      poReceivedDate: "2022-12-28T00:00:00",
      problemDescription: "Outer layer of paper has wrinkles.  No impact for using.",
      problemTypeDescription: "Out of Spec",
      problemTypeId: 19,
      qualityCode: "Q6",
      quantity: "30000",
      responseDate: "",
      responseRequired: false,
      rootCause: "Response not required",
      shortTerm: "Response not required.  Service Thread will accept these spools and use in production.",
      status: 2,
      statusDescription: "Closed",
      supplier: "PALM01",
      vendorItemWithDescription: "4.150 X 1.031 X 0.125 | PM01701",
      vendorWithName: "PALM01 | PALMETTO PAPER TUBE, INC.",
   },
   THEMES,
   THIRTY_MINUTES_MS: 1800000,
   TIMERS,
   TOTP_ID: 3,
   TWENTY_FIVE_MINUTES_MS: 1500000,
   TWENTY_MINUTES_MS: 1200000,
   UNBOUNDED_RESULT_ROW_COUNT,
   UOM_LIST,
   US_STATE_LIST: [
      "Alabama",
      "Alaska",
      "American Samoa",
      "Arizona",
      "Arkansas",
      "California",
      "Colorado",
      "Connecticut",
      "Delaware",
      "District of Columbia",
      "Federated States of Micronesia",
      "Florida",
      "Georgia",
      "Guam",
      "Hawaii",
      "Idaho",
      "Illinois",
      "Indiana",
      "Iowa",
      "Kansas",
      "Kentucky",
      "Louisiana",
      "Maine",
      "Marshall Islands",
      "Maryland",
      "Massachusetts",
      "Michigan",
      "Minnesota",
      "Mississippi",
      "Missouri",
      "Montana",
      "Nebraska",
      "Nevada",
      "New Hampshire",
      "New Jersey",
      "New Mexico",
      "New York",
      "North Carolina",
      "North Dakota",
      "Northern Mariana Islands",
      "Ohio",
      "Oklahoma",
      "Oregon",
      "Palau",
      "Pennsylvania",
      "Puerto Rico",
      "Rhode Island",
      "South Carolina",
      "South Dakota",
      "Tennessee",
      "Texas",
      "Utah",
      "Vermont",
      "Virgin Islands",
      "Virginia",
      "Washington",
      "West Virginia",
      "Wisconsin",
      "Wyoming",
   ],
   VALID_ORDER_SITES,
   WITH_ROLES_INVENTORYDASHBOARD_SCREENSWITCHES,
   WITH_ROLES_INVENTORYDASHBOARD_SWITCHES,
   YARN_JOINING_TYPES: {
      AIR_SPLICE: { value: "Air Splice", label: "Air Splice" },
      THREAD_SPLICE: { value: "Thread Splice", label: "Thread Splice" },
      WEAVE_KNOT: { value: "Weave Knot", label: "Weave Knot" },
      LAP: { value: "Lap", label: "Lap" },
      NO_SPLICES: { value: "No Splices", label: "No Splices" },
   },
   ZIP_CODE_REGEX: /^[0-9]{5}$/,
};

export default constants;
